<div class="card flex justify-content-center quarterly-outcome-list m-t-12">
  <p-accordion class="w-full" [activeIndex]="0">
    <p-accordionTab>
      <ng-template pTemplate="header">
        <div class="dis-flex flex-col">
          <div class="dis-flex flex-row">
            <p-chip class="b3 radius-8" [label]="outcomesData?.tagged" />
            <p-divider class="vertical-divider" layout="vertical" />
            <p-chip
              class="b3 radius-8 status-chip"
              [ngClass]="{
                'not-started': outcomesData.status === 1,
                ongoing: outcomesData.status === 2,
                completed: outcomesData.status === 3,
                delayed: outcomesData.status === 4,
                terminated: outcomesData.status === 5
              }"
              [label]="getLabel(outcomesData.status)"
            />
          </div>
          <div class="dis-flex flex-m m-t-15">
            <p-avatar label="STO" class="outcome-type m-r-10 p-avatar-square" />
            <p class="b1 title m-b-0 wd-90">{{ outcomesData.value }}</p>
          </div>
        </div>
      </ng-template>

      @if(outcomesData?.milestones?.length>0){
      <p-table
        class="table-bordered"
        [value]="outcomesData?.milestones"
        [tableStyle]="{ 'min-width': '50rem' }"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="wd-40">Milestone Name</th>
            <th>Start Date</th>
            <th>Planned End Date</th>
            <th>Actual End Date</th>
            <th>Status</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-milestone>
          <tr>
            <td>{{ milestone?.value || 'NA'}}</td>
            <td>{{ (milestone?.start_date | dateFormatPipe)  || 'NA'}}</td>
            <td>{{ (milestone?.plan_end_date | dateFormatPipe) || 'NA' }}</td>
            <td>{{ (milestone?.actual_end_date | dateFormatPipe) || 'NA'}}</td>
            <td>
              <p-chip
                *ngIf="milestone.status === 1"
                class="b3 font-medium radius-8 milestone-count-chip not-started"
                [label]="getLabel(milestone.status)"
              />
              <p-chip
                *ngIf="milestone.status === 2"
                class="b3 font-medium radius-8 milestone-count-chip ongoing"
                [label]="getLabel(milestone.status)"
              />
              <p-chip
                *ngIf="milestone.status === 3"
                class="b3 font-medium radius-8 milestone-count-chip completed"
                [label]="getLabel(milestone.status)"
              />
              <p-chip
                *ngIf="milestone.status === 4"
                class="b3 font-medium radius-8 milestone-count-chip delayed"
                [label]="getLabel(milestone.status)"
              />
              <p-chip
                *ngIf="milestone.status === 5"
                class="b3 font-medium radius-8 milestone-count-chip terminated"
                [label]="getLabel(milestone.status)"
              />
            </td>
          </tr>
        </ng-template>
      </p-table>
      } @else {
      <div class="milestone-table">
        <h3>No milestones created yet</h3>
      </div>
      }
    </p-accordionTab>
  </p-accordion>
</div>
